
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-i-prelims-mock-test",
      function () {
        return require("private-next-pages/tnpsc-group-i-prelims-mock-test/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-i-prelims-mock-test"])
      });
    }
  